import { RSAA } from 'redux-api-middleware';
//import moment from 'moment';

// Constants
export const DOCUMENTS_IS_FETCHING = 'DOCUMENTS_IS_FETCHING';
export const DOCUMENTS_GET_LIST_SUCCESS = 'DOCUMENTS_GET_LIST_SUCCESS';
export const DOCUMENTS_API_ERROR = 'DOCUMENTS_API_ERROR';
export const DOCUMENTS_DOWNLOAD_START = 'DOCUMENTS_DOWNLOAD_START';
export const DOCUMENTS_DOWNLOAD_END = 'DOCUMENTS_DOWNLOAD_END';

// const getDateRange = () => {
//     let firstDay  = moment();
//     let lastDay = firstDay;
//     firstDay = firstDay.add(-2, "Y");
//     lastDay = lastDay.add(90, "day");
//     return {
//         firstDay,
//         lastDay
//     };
// };

// --> Documents actions
export const getDocumentList = queryString => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_DOCUMENT',
      controlAction: 'collection',
      queryString,
      types: [
        DOCUMENTS_IS_FETCHING,
        {
          type: DOCUMENTS_GET_LIST_SUCCESS,
          meta: { ...queryString }
        },
        DOCUMENTS_API_ERROR
      ]
    }
  };
};

export const startDownload = () => {
  return dispatch => {
    dispatch({ type: DOCUMENTS_DOWNLOAD_START });
  };
};

export const stopDownload = () => {
  return dispatch => {
    dispatch({ type: DOCUMENTS_DOWNLOAD_END });
  };
};

// Initial State
export const initialState = {
  sorting: {
    prop: 'name',
    direction: 'asc'
  },
  filters: [
    {
      key: 'documentType',
      label: 'Category',
      isRadio: true,
      values: [
        { value: 'All', label: 'All' },
        { value: 'Contract', label: 'Contract' },
        { value: 'SBC', label: 'Summary of Benefits and Coverage Information' },
        { value: 'TAX', label: '1095 Data File' }
      ],
      selectedValue: null
    }
  ],
  defaultSearchParams: {
    perPage: 10,
    page: 1
  },
  pagination: {
    page: 1,
    total: 3
  },
  searchQuery: null,
  isFetching: false,
  items: [],
  selectedItem: null,
  error: null,
  inDownload: ''
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case DOCUMENTS_IS_FETCHING:
      return { ...state, isFetching: true, error: null };

    case DOCUMENTS_DOWNLOAD_START:
      return { ...state, isFetching: true, error: null, inDownload: 'DOWNLOADING DOCUMENT' };

    case DOCUMENTS_DOWNLOAD_END:
      return { ...state, isFetching: false, error: null, inDownload: '' };

    case DOCUMENTS_GET_LIST_SUCCESS:
      let prop, direction;
      if (action.meta.orderBy) {
        let splitted = action.meta.orderBy.split(':');
        prop = splitted[0];
        if (prop === state.sorting.prop) {
          direction = splitted[1];
        } else {
          direction = 'asc';
        }
      } else {
        prop = '';
      }
      direction = direction === 'asc' ? ':desc' : ':asc';

      const out = {
        ...state,
        isFetching: false,
        error: null,
        items: action.payload.items,
        filters: [...state.filters].map(e => {
          let selectedValue = action.meta[e.key] ? action.meta[e.key] : null;

          return {
            ...e,
            selectedValue
          };
        }),

        pagination: {
          ...state.pagination,
          page: +action.meta.page,
          total: action.payload.pageCount
        },
        sorting: {
          ...state.sorting,
          prop: prop,
          direction: direction
        },
        searchQuery: action.meta && action.meta.search ? action.meta.search : null
      };
      return out;

    case DOCUMENTS_API_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    case '@@router/LOCATION_CHANGE':
      return {
        ...state
      };

    default:
      return state;
  }
};
